import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';

import { OfficeAction, RoleAction, UserAction } from '../../store/actions';

class Form extends PureComponent {
  static propTypes = {
    authHasOffice: PropTypes.bool,
    authOfficeId: PropTypes.number,
    authOfficeName: PropTypes.string,
    createUser: PropTypes.func,
    editUser: PropTypes.func,
    getOffices: PropTypes.func,
    getRoles: PropTypes.func,
    getUser: PropTypes.func,
    offices: PropTypes.arrayOf(PropTypes.object),
    roles: PropTypes.arrayOf(PropTypes.object),
    user: PropTypes.object,
    userId: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = this.getInitialState(props.user);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.userId) {
      this.props.getUser(this.props.userId);
    }
    this.props.getRoles();
  }

  componentDidUpdate(props, _state, _snapshot) {
    if (JSON.stringify(props.user) !== JSON.stringify(this.props.user)) {
      this.setState({ ...this.getInitialState(this.props.user) });
    }
  }

  getInitialState(user) {
    const officeId = [this.props.authOfficeId, user?.office_id, '']?.find?.(
      i => i,
    );
    const officeSelected = [
      this.props.authOfficeId && {
        label: this.props.authOfficeName,
        value: this.props.authOfficeId,
      },
      user?.office?.id && {
        label: user?.office?.name,
        value: user?.office?.id,
      },
      '',
    ]?.find?.(i => i);
    return {
      email: user?.email || '',
      name: user?.name || '',
      office_id: officeId || '',
      office_selected: officeSelected || '',
      role_id: user?.roles?.find?.(i => i)?.id || '',
      role_selected:
        user?.roles
          ?.map?.(row => ({ label: row.name, value: row.id }))
          ?.find?.(i => i) || '',
    };
  }

  onChange(event) {
    const { target: { name, value } = {} } = event;
    this.setState({ [name]: value });
  }

  onClear(_) {
    this.setState(this.getInitialState());
  }

  onSelect(option, action) {
    const { _name, name } = action;
    const { value } = option;
    this.setState({ [name]: option, [_name]: value });
  }

  onSubmit(event) {
    event.preventDefault();
    if (!confirm('Are you sure?')) {
      return;
    }
    if (this.props.userId) {
      this.props.editUser(this.props.userId, this.state);
    } else {
      this.props.createUser(this.state);
    }
  }

  render() {
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">
                {this.props.userId ? 'Edit' : 'Create'} User
              </h3>
            </div>
            <form onSubmit={this.onSubmit.bind(this)}>
              <div className="card-body">
                {!this.props.authHasOffice && (
                  <div className="form-row">
                    <div className="form-group col">
                      <label htmlFor="office_id">Office</label>
                      <Select
                        id="office_id"
                        isDisabled={this.props.authHasOffice}
                        name="office_selected"
                        onChange={(option, action) =>
                          this.onSelect(option, {
                            ...action,
                            _name: 'office_id',
                          })
                        }
                        onInputChange={value => {
                          value && this.props.getOffices({ query: value });
                        }}
                        options={this.props.offices}
                        placeholder="Select Office"
                        value={this.state.office_selected}
                      />
                    </div>
                  </div>
                )}
                <div className="form-row">
                  <div className="form-group col">
                    <label htmlFor="name">Name</label>
                    <input
                      className="form-control"
                      id="name"
                      name="name"
                      onChange={this.onChange}
                      placeholder="Name"
                      type="text"
                      value={this.state.name}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="email">Email</label>
                    <input
                      className="form-control"
                      id="email"
                      name="email"
                      onChange={this.onChange}
                      placeholder="Email"
                      type="email"
                      value={this.state.email}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="role_id">Role</label>
                    <Select
                      id="role_id"
                      name="role_selected"
                      onChange={(option, action) =>
                        this.onSelect(option, { ...action, _name: 'role_id' })
                      }
                      onInputChange={value => {
                        value && this.props.getRoles({ query: value });
                      }}
                      options={this.props.roles}
                      placeholder="Select Role"
                      value={this.state.role_selected}
                    />
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <button className="btn btn-primary" type="submit">
                  Save
                </button>
                <button
                  className="btn btn-warning float-right"
                  onClick={this.onClear.bind(this)}
                  type="reset"
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  authHasOffice: !!state?.auth?.office,
  authOfficeId: state?.auth?.office?.id,
  authOfficeName: state?.auth?.office?.name,
  offices: state?.office?.list?.data?.map?.(row => ({
    label: row.name,
    value: row.id,
  })),
  roles: state?.role?.list?.data?.map?.(row => ({
    label: row.name,
    value: row.id,
  })),
  user: state?.user?.detail,
  userId: Number(props?.match?.params?.id),
});

const mapDispatchToProps = dispatch => ({
  createUser: data => dispatch(UserAction.createUser(data)),
  editUser: (id, data) => dispatch(UserAction.editUser(id, data)),
  getOffices: params => dispatch(OfficeAction.getOffices(params)),
  getRoles: params => dispatch(RoleAction.getRoles(params)),
  getUser: id => dispatch(UserAction.getUser(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
